import type { OrderCommunicationSubscriptions } from '#domain/Subscription.ts';

export const createTourSubscriptions = (tourId: string): OrderCommunicationSubscriptions => ({
    items: [
        { eventType: 'tour-started', importance: 'low', tourId },
        { eventType: 'tour-finished', importance: 'low', tourId },
        { eventType: 'problem-reported', importance: 'high', tourId },
        { eventType: 'deviation-reported', importance: 'medium', tourId },
    ],
});
